import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { createDailyRacePrizeRows, formatKopecksInput } from "../helpers/dailyRacePrizes";
import SpaceBetween from "@cloudscape-design/components/space-between";
import ProgressiveImage from "react-progressive-graceful-image";
import Poster from "../assets/poster.png";
import { tournamentsStore } from "../stores/tournaments";
import Tabs from "@cloudscape-design/components/tabs";
import Container from "@cloudscape-design/components/container";
import { tournamentsAddModalStore } from "../stores/tournamentsAddModal";
import { tournamentsEditModalStore } from "../stores/tournamentsEditModal";
import { userStore } from "../stores/access";
import FormField from "@cloudscape-design/components/form-field";
/* ------- */

class Tournaments extends React.Component {
	constructor(props) {
		super(props);
	}





	componentDidMount() {
		this.props.Interface.loadTournamentList(undefined, "tournaments", this.props.tournaments.currentStatus?.value);
	}



	render() {
		return (
			<>
			<>
				{this.props.tournaments.loaded && this.props.tournaments.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.tournaments.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.tournaments.error.code} | request timestamp: {this.props.tournaments.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Container
				>
					<Table
						stickyHeader="true"
						trackBy="id"
						loading={!this.props.tournaments.loaded}
						sortingColumn={{ sortingField: this.props.tournaments.sorting.sortingColumn.column }}
						sortingDescending={this.props.tournaments.sorting.isDescending}
						onSortingChange={(sorting) => {
							this.props.setTournaments({ ...this.props.tournaments, sorting: {
									...this.props.tournaments.sorting,
									sortingColumn: {
										order: !sorting.detail.isDescending ? "ASC" : "DESC",
										column: sorting.detail.sortingColumn.sortingField
									},
									isDescending: sorting.detail.isDescending,
								} });

							setTimeout(() => {
								this.props.Interface.loadTournamentList(undefined, "tournaments", this.props.tournaments.currentStatus?.value);
							}, 250);
						}}
						columnDefinitions={[
							{
								width: 20,
								id: "id",
								header: "ID",
								sortingField: "id",
								cell: (item) => (
									<Button
										iconName={"status-in-progress"}
										className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
										variant="normal"
										onClick={() => {
											setTimeout(() => {
												const rawBotConfig = item.bot_config || item.config_bot;
												let configBot = { enabled: false, bots: [] };
												if (rawBotConfig) {
													try {
														configBot = typeof rawBotConfig === "string"
															? JSON.parse(rawBotConfig)
															: rawBotConfig;
													} catch (error) {
														configBot = { enabled: false, bots: [] };
													}
												}
												this.props.setTournamentsEditModal({
													...this.props.tournamentsEditModal,
													...item,
													show: true,
													modalType: "tournaments",
													id: item.id,
													name: item.name,
													slug: item.slug,
													translationType: item.translation_type,
													tournamentType: { value: item.type, label: item.type.replaceAll("_"," ") },
													status: this.props.tournamentsEditModal.currentOption.statusType.filter((tournament) => tournament.value === item.status)[0],
													game_ids: item.game_ids ? JSON.parse(item.game_ids) : [],
													provider_ids: item.provider_ids ? JSON.parse(item.provider_ids) : [],
													winners: item.winners.toString(),
													prize_pool: item.name === "dailyRace" ? formatKopecksInput(item.prize_pool) : (item.prize_pool / 100).toString(),
													from: item.start_time.replace(" ", "T"),
													to: item.end_time.replace(" ", "T"),
													min_bet: item.minbet ? item.minbet / 100 : "",
													banner: item.banner_url || null,
													vip_level: item.vip_lvl !== null ? item.vip_lvl.toString() : null,
													min_deposits: item.min_deposits ? item.min_deposits.toString() : "0",
													promo_scope: item.promo_scope || "tournament_games",
													config_bot: configBot,
													// The daily race always shows 100 places; a saved prize of 0 is kept.
													prizeDistribution: item.name === "dailyRace"
														? createDailyRacePrizeRows(JSON.parse(item.prize_distribution).filter((element) => element.place).map((element) => ({ place: element.place, prize: formatKopecksInput(element.prize) })))
														: JSON.parse(item.prize_distribution).filter((element) => element.prize).map((element) => ({...element, prize: element.prize / 100})) || [{ place: 1, prize: "" }],
												});
											}, 0);
										}}
										children={item.id}
									/>
								),
							},
							{
								width: 70,
								id: "banner_url",
								header: "Banner",
								sortingField: "banner_url",
								cell: (item) => (
									<ProgressiveImage src={item.banner_url} placeholder={Poster}>
										{(src) => <img style={{ width: "70px" }} src={src} alt={item.name} />}
									</ProgressiveImage>
								),
							},
							{ id: "name", header: "Name", sortingField: "name", cell: (item) => item.name },
							{ id: "translation_type", header: "Translation type", sortingField: "translation_type", cell: (item) => item.translation_type },
							{ id: "type", header: "Type", sortingField: "type", cell: (item) => item.type },
							{ id: "slug", header: "Slug", sortingField: "slug", cell: (item) => item.slug ? item.slug : "None" },
							{ id: "minbet", header: "Min bet", sortingField: "minbet", cell: (item) => item.minbet ? item.minbet/100 : 0 },
							{ id: "vip_lvl", header: "Vip lvl", sortingField: "vip_lvl", cell: (item) => item.vip_lvl ? item.vip_lvl : 0 },
							{ id: "deposit_count", header: "Deposit count", sortingField: "deposit_count", cell: (item) => item.deposit_count ? item.deposit_count : 0 },
							{ id: "promo_scope", header: "Promo scope", sortingField: "promo_scope", cell: (item) => item.promo_scope ? item.promo_scope : "None" },
							{ id: "game_ids", header: "Games", sortingField: "game_ids", cell: (item) => item.game_ids ? JSON.parse(item.game_ids).length : "None"  },
							{ id: "provider_ids", header: "Providers", sortingField: "provider_ids", cell: (item) => item.provider_ids ? JSON.parse(item.provider_ids).length : "None" },
							{ id: "winners", header: "Winners", sortingField: "winners", cell: (item) => item.winners },
							{ id: "prize_pool", header: "Prize pool", sortingField: "prize_pool", cell: (item) => <>{new Intl.NumberFormat("ru-RU").format(item.prize_pool/100)} RUB.</>  },
							{ id: "recurrence", header: "Recurrence", sortingField: "recurrence", cell: (item) => item.recurrence === "" || !item.recurrence ? "None" : item.recurrence },
							{ id: "from", header: "From", sortingField: "from", cell: (item) => <>{new Date(item.start_time).toLocaleDateString() + " " + new Date(item.start_time).toLocaleTimeString()}</> },
							{ id: "to", header: "To", sortingField: "to", cell: (item) => <>{new Date(item.end_time).toLocaleDateString() + " " + new Date(item.end_time).toLocaleTimeString()}</> },
							{ id: "status", header: "Status", sortingField: "status", cell: (item) => item.status}
						]}
						items={this.props.tournaments.data}
						pagination={
							<Pagination
								disabled={!this.props.tournaments.loaded}
								currentPageIndex={this.props.tournaments.pagination.current}
								pagesCount={this.props.tournaments.pagination.total}
								onChange={(page) => {
									this.props.setTournaments({ ...this.props.tournaments, pagination: { ...this.props.tournaments.pagination, current: page.detail.currentPageIndex } });
									setTimeout(() => {
										this.props.Interface.loadTournamentList(undefined, "tournaments", this.props.tournaments.currentStatus?.value);
									}, 250)
								}}
							/>
						}
						preferences={
							<Preferences
								cancelLabel="Cancel"
								confirmLabel="Confirm"
								pageSizePreference={{ title: "Tournaments per page", options: this.props.config.tournaments.preferences.perPage }}
								preferences={{ pageSize: this.props.config.tournaments.perPage }}
								title="Preferences"
								onConfirm={(preferences) => {
									localStorage.setItem("tournaments.perPage", preferences.detail.pageSize);
									this.props.setConfig({ ...this.props.config, tournaments: { ...this.props.config.tournaments, perPage: preferences.detail.pageSize } });

									setTimeout(() => {
										this.props.Interface.loadTournamentList(undefined, "tournaments", this.props.tournaments.currentStatus?.value);
									}, 250);
								}}
							/>
						}
						filter={
							<Box
								margin={{ bottom: "m" }}
								children={
									<Grid
										gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
									>
										<Select
											selectedOption={this.props.tournaments.currentStatus}
											onChange={({ detail }) =>
												{
													this.props.setTournaments({
														...this.props.tournaments,
														currentStatus: detail.selectedOption
													})
												}
											}
											options={this.props.tournaments.currentOption.status}
											placeholder="Select a status"
										/>
										<Button disabled={this.props.tournaments.currentStatus === undefined} onClick={() => {
											this.props.setTournaments({ ...this.props.tournaments, pagination: { ...this.props.tournaments.pagination, current: 0 } });
											setTimeout(() => {
												this.props.Interface.loadTournamentList(undefined, "tournaments", this.props.tournaments.currentStatus?.value);
											}, 0);
										}}>
											Submit
										</Button>
									</Grid>
								}
							/>
						}
						header={<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Tournaments"
									counter={
										<>
											({this.props.tournaments.pagination.count})
										</>
									}
									actions={
										<SpaceBetween direction="horizontal" size="l">
											<Button
												disabled={!this.props.tournaments.loaded}
												className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
												onClick={() => {
													setTimeout(() => {
														this.props.setTournamentsAddModal({ ...this.props.tournamentsAddModal, show: true, modalType: "tournaments" });
													}, 0);
												}}
												variant="primary"
												children="Add tournament"
											/>
										</SpaceBetween>
									}
								/>
							}
						/>}
						empty="No Tournaments found with requested filter"
					/>
				</Container>
			</>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const tournaments = useRecoilValue(tournamentsStore);
		const setTournaments = useSetRecoilState(tournamentsStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const user= useRecoilValue(userStore);

		const tournamentsEditModal = useRecoilValue(tournamentsEditModalStore);
		const setTournamentsEditModal = useSetRecoilState(tournamentsEditModalStore);
		const tournamentsAddModal = useRecoilValue(tournamentsAddModalStore);
		const setTournamentsAddModal = useSetRecoilState(tournamentsAddModalStore);
		return <Component {...props} user={user} tournamentsEditModal={tournamentsEditModal} setTournamentsEditModal={setTournamentsEditModal} tournamentsAddModal={tournamentsAddModal} setTournamentsAddModal={setTournamentsAddModal} tournaments={tournaments} setTournaments={setTournaments} config={config} setConfig={setConfig}  />;
	};
}

export default withRecoil(Tournaments);
